<template>
  <div class="guide" >
    <img src='/static/images/guide.png' v-if="$store.state.exchangeinfo.image==''" class="backgroudimg">
    <img :src='$store.state.exchangeinfo.image' v-else onerror="src='/static/images/guide.png'" class="backgroudimg">
    <div class="ebox">
      <router-link  :to="this.$store.state.exchangeinfo.tourist == 0?'':{path: '/eindex', query: {gid:gid}}">
       <img :src='this.$store.state.exchangeinfo.logo' onerror="src='/static/images/login_logo1.png'" class="logo">
      </router-link>
      <div style="margin-top: 31%;"></div> 
      <div style="padding: 3% 6% 0 8%;max-height: 30%;margin: 0 25px;overflow: auto;background:rgba(0,0,0,.1);border-radius: 5px;">
        <p style="margin-bottom: 20px;font-size: 0.28rem" class="col-fff ft16">{{this.$store.state.exchangeinfo.head}}</p>
        <p class="col-fff ft16" style="margin-bottom: 20px;white-space:pre-wrap; text-indent: 28px;">{{this.$store.state.exchangeinfo.body}}</p>
        <p style="text-align: right;margin-bottom: 20px" class="col-fff ft16">{{this.$store.state.exchangeinfo.tail}}</p>  
      </div>
      <div class="loginbtn" style="padding: 3% 8%">
        <van-button size="large"  @click="go()" >{{this.$store.state.exchangeinfo.button}}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import SIdentify from '../../components/identify'
  import md5 from 'js-md5';
  export default {
    name: "index",
    data () {
      return {
        account:'',
        baurl:'',
        gid:this.$route.query.gid
      }
    },
    methods: {
      go:function () {
        this.$store.state.exchangeinfo.tourist == 0?this.$router.push({ name: 'Elogin',query:{gid:this.gid}}):this.$router.push({ name: 'Eindex',query:{gid:this.gid}})
        // this.$router.push({ name: 'Elogin',query:{gid:this.gid}})
      },
    },
    mounted () {
      localStorage.clear();
      setTimeout(()=>{
        this.$store.state.exchangeinfo.image==""||this.$store.state.exchangeinfo.image==null||this.$store.state.exchangeinfo.image==undefined?this.baurl='/static/images/guide.png':this.baurl=this.$store.state.exchangeinfo.image
      },500)
    },
  }
</script>

<style lang="less" scoped>
  .guide{
    min-height: 100vh;
    // background: url("/static/images/guide.png") no-repeat center ;
    // background-size: 100% 100%;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    .col-fff {
      color: #fff;
    }
    .ebox{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
    .backgroudimg{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
    }
    .logo{
      height: auto;
      width: 30%;
      margin:20px;
    }
    .loginbtn{
      padding: 0 60px;
      .van-button--default {
        color: #fff;
        background-color: transparent;
        border: 1px solid #fff;
        border-radius: 6px;
        margin-top: 50px;
      }
    }
  }
.theme-bg,.van-checkbox--checked,.van-swipe__indicator--active{background-color:red!important;color:#ffffff!important}
.theme-col,.van-icon-checked{color: red!important;}
.col-hover:hover{color: red!important;}
.col-on{color: red!important;}
.col-focus:focus{color: red!important;}
.col-checked:checked:before{
  color: red!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/exchange/guide.vue